import { getAuthHeaders } from "../../utils/authHeader";
import axiosInstance from "../../utils/axiosInstance";

const BASE_URL = `/user`;

export const apiLoginUser = ({ email, password }) =>
  axiosInstance.post(
    `${BASE_URL}/login`,
    { email, password },
    { withCredentials: true },
  );

export const registerUser = ({
  name,
  email,
  phoneNumber,
  password,
  roles,
  timezone,
}) =>
  axiosInstance.post(`${BASE_URL}/register`, {
    name,
    email,
    phoneNumber,
    password,
    roles,
    timezone,
  });

export const verifyOtp = ({ otp, email }) =>
  axiosInstance.post(
    `${BASE_URL}/verify-otp`,
    { otp, email },
    { withCredentials: true },
  );

export const forgotPassword = ({ email }) =>
  axiosInstance.post(
    `${BASE_URL}/forgot-password`,
    { email },
    { withCredentials: true },
  );

export const resetPassword = ({ token, newPassword }) =>
  axiosInstance.put(
    `${BASE_URL}/reset-password`,
    { token, newPassword },
    { withCredentials: true },
  );

export const approveClient = ({ uuid }) =>
  axiosInstance.put(`${BASE_URL}/approve`, { uuid }, getAuthHeaders());

export const createUserActivityAPI = async (data) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/create-activity`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const getUserActivityAPI = () =>
  axiosInstance.get(`${BASE_URL}/activity`, getAuthHeaders());

export const deleteUserActivityAPI = ({ assistantId, userId }) =>
  axiosInstance.delete(
    `${BASE_URL}/activity/${assistantId}/${userId}`,
    getAuthHeaders(),
  );

export const editUserAPI = ({ uuid, data }) =>
  axiosInstance.put(`${BASE_URL}/${uuid}`, data, getAuthHeaders());

export const getLoggedInUserAPI = (uuid) =>
  axiosInstance.get(`${BASE_URL}/${uuid}`, getAuthHeaders());

export const createUserAPI = async ({ data }) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/create-user`,
    { data },
    getAuthHeaders(),
  );
  return res.data;
};

export const syncUserData = async ({ setting }) => {
  const res = await axiosInstance.get(`${BASE_URL}/sync-data`, {
    ...getAuthHeaders(),
    params: { setting },
  });
  return res.data;
};
